import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';
import { default as RoutesIndex } from './routes/Index';

import 'bootstrap/dist/css/bootstrap.css';
import 'dripicons/webfont/webfont.css';
import './Index.css';

ReactDOM.render(<RoutesIndex/>, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js